import React from 'react';
import { useTranslation } from 'react-i18next'; // Ավելացված է
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faSync, faClock, faUsers, faHourglassHalf, 
    faCheckCircle, faExclamationTriangle, 
    faPlay, faHistory, faTimesCircle, faEdit,
    faCheckDouble 
} from '@fortawesome/free-solid-svg-icons';

const OrderStats = ({ stats }) => {
    const { t } = useTranslation(); // Ինիցիալիզացիա

    const cardData = [
        { title: t('stats_all'), value: stats.total, icon: faSync, grad: "linear-gradient(135deg, #4318FF 0%, #5E37FF 100%)" },
        { title: t('stats_new'), value: stats.new, icon: faClock, grad: "linear-gradient(135deg, #FF9933 0%, #FFB366 100%)" },
        { title: t('stats_processing'), value: stats.processing, icon: faUsers, grad: "linear-gradient(135deg, #4318FF 0%, #5E3AFF 100%)" },
        { title: t('stats_pending'), value: stats.pending, icon: faHourglassHalf, grad: "linear-gradient(135deg, #f1c40f 0%, #f39c12 100%)" },
        { title: t('stats_confirmed'), value: stats.confirmed, icon: faCheckCircle, grad: "linear-gradient(135deg, #3498db 0%, #2980b9 100%)" },
        { title: t('stats_mismatch'), value: stats.mismatch, icon: faExclamationTriangle, grad: "linear-gradient(135deg, #E74C3C 0%, #c0392b 100%)" },
        { title: t('stats_modified'), value: stats.modified, icon: faEdit, grad: "linear-gradient(135deg, #ecc94b 0%, #d69e2e 100%)" },
        { title: t('stats_in_progress'), value: stats.in_progress, icon: faPlay, grad: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)" },
        { title: t('stats_pending_finish'), value: stats.pending_finish, icon: faCheckDouble, grad: "linear-gradient(135deg, #f6ad55 0%, #ed8936 100%)" },
        { title: t('stats_finished'), value: stats.finished, icon: faHistory, grad: "linear-gradient(135deg, #01B574 0%, #2AF598 100%)" },
        { title: t('stats_cancelled'), value: stats.cancelled, icon: faTimesCircle, grad: "linear-gradient(135deg, #718096 0%, #4A5568 100%)" }
    ];

    return (
        <div style={styles.analyticsRow}>
            {cardData.map((card, index) => (
                <div key={index} style={{ ...styles.analyticCard, background: card.grad }}>
                    <div style={styles.anaIcon}>
                        <FontAwesomeIcon icon={card.icon} />
                    </div>
                    <div>
                        <p style={styles.anaTitle}>{card.title}</p>
                        <h3 style={styles.anaValue}>{card.value || 0}</h3>
                    </div>
                </div>
            ))}
        </div>
    );
};



const styles = {
    analyticsRow: { 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', 
        gap: '12px', 
        marginBottom: '25px',
        padding: '5px'
    },
    analyticCard: { 
        padding: '15px', 
        borderRadius: '18px', 
        color: 'white', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '10px', 
        boxShadow: '0px 8px 15px rgba(0,0,0,0.05)',
        transition: 'transform 0.2s',
        minWidth: 0 // Կարևոր է grid-ի մեջ overflow-ից խուսափելու համար
    },
    anaIcon: { 
        minWidth: '32px', 
        width: '32px', 
        height: '32px', 
        borderRadius: '8px', 
        background: 'rgba(255,255,255,0.2)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
    },
    anaTitle: { 
        fontSize: '9px', 
        opacity: 0.9, 
        margin: 0, 
        textTransform: 'uppercase', 
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    anaValue: { 
        fontSize: '17px', 
        fontWeight: '800', 
        margin: '1px 0 0 0' 
    }
};

export default OrderStats;